import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  photo: {
    position: 'absolute',
    width: '100%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  photoWrapper: {
    borderRadius: 4,
    paddingBottom: '56%',
    marginBottom: '8px',
    position: 'relative',
    overflow: 'hidden',
  },
  squarePhotoWrapper: {
    paddingBottom: '100%',
  },
  cardTitle: ({ titleColor }) => ({
    fontWeight: 700,
    lineHeight: '28px',
    color: titleColor,
  }),
  cardSubtitle: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  horizontalCard: {
    width: '100%',
    paddingLeft: '15px',
    paddingRight: '20px',
    [theme.breakpoints.only('xs')]: {
      paddingRight: '8px',
    },
  },
  verticalCard: {
    width: '100%',
  },
  cardLink: {
    color: 'black',
    '&:hover': {
      background: '#FCFCFC',
      color: 'black !important',
    },
  },
  chip: {
    position: 'absolute',
    top: '16px',
    left: '5px',
    height: '25px',
    fontSize: '0.8em',
    fontWeight: 'bold',
    zIndex: 2,
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
  },
  cta: {
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  coachAvatar: {
    border: '2px solid #DBD2C1',
    width: '34px',
    height: '34px',
    marginRight: '0.75rem',
    fontSize: '1.5rem',
    color: '#fff',
    backgroundColor: '#d8d8d8',
  },
  externalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logoWrapper: ({ cardStyle }) => ({
    marginTop: 'auto',
    marginRight: cardStyle === 'column' ? '16px' : '0',
    '& img': {
      float: 'inline-start',
    },
  }),
}))

export default useStyles
